import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, Response } from '@core/api';
import { Observable } from 'rxjs';
import { AssignmentSource } from './assignment-source.model';

@Injectable({
  providedIn: 'root'
})
export class AssignmentSourceService {
  constructor(private http: HttpClient) { }

  list(request: FilterRequest): Observable<Response<AssignmentSource[]>> {
    return this.http.post<Response<AssignmentSource[]>>(environment.apiUrl + '/api/AssignmentSource/List', request);
  }
}
